import { render, staticRenderFns } from "./EzDrm.vue?vue&type=template&id=24f28eb5&"
import script from "./EzDrm.vue?vue&type=script&lang=js&"
export * from "./EzDrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports